<h2 mat-dialog-title>Add Gallery</h2>

<form [formGroup]="addgalleryform" (ngSubmit)="onFormSubmit()">
    <div mat-dialog-content class="content">
        <div class="album">
            <img src="https://aieventzo.com/upload/{{event_id}}/gallery/{{this.imagePath}}" style="width: 150px;
              height: 150px;">
        </div>
        <div class="row">
            <mat-label>Select Image</mat-label>
            <div class="input-group mb-3">
                <input type="file" class="form-control" id="inputGroupFile01" #file accept='image/*'
                    id="exampleInputFile" (change)="previewpimage(file.files)" [required]="true">
            </div>

            <mat-form-field appearance="outline">
                <mat-label>Title</mat-label>
                <input [ngModel]="title" formControlName="title" matInput placeholder="Enter Title" required="true">
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Description</mat-label>
                <input matInput placeholder="Enter Description" formControlName="description" [required]="true">
            </mat-form-field>

        </div>

        <div mat-dialog-actions class="action" align="end">
            <button mat-raised-button type="button" color="warn" [mat-dialog-close]="false">Cancel</button>
            <button mat-raised-button type="submit" color="primary">Add</button>
        </div>
    </div>
</form>